module.exports = __webpack_public_path__ + "static/media/iBookMark_27.40fb9238.webp";